"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PromoCarousel", {
  enumerable: true,
  get: function () {
    return _PromoCarousel.PromoCarousel;
  }
});
Object.defineProperty(exports, "PromoCarouselProps", {
  enumerable: true,
  get: function () {
    return _PromoCarousel.PromoCarouselProps;
  }
});
var _PromoCarousel = require("./PromoCarousel");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUHJvbW9DYXJvdXNlbCIsInJlcXVpcmUiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Qcm9tb0Nhcm91c2VsL2luZGV4LnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBQcm9tb0Nhcm91c2VsLCBQcm9tb0Nhcm91c2VsUHJvcHMgfSBmcm9tIFwiLi9Qcm9tb0Nhcm91c2VsXCJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxjQUFBLEdBQUFDLE9BQUEiLCJpZ25vcmVMaXN0IjpbXX0=